/**
 * Az esemény amivel meggátoljuk a contextmenü felugrását.
 * @param e - Az esemény, amire hívjuk a függvényt.
 */
export default function preventCallback (e: Event): void {
  e.preventDefault()
  e.stopPropagation()
  e.stopImmediatePropagation()
}
